import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function LeadSection() {
  return <section id="lead" className="py-10 md:py-32 bg-charcoal relative" data-id="element-188">
      <div className="max-w-3xl mx-auto px-6" data-id="element-189">
        <FadeIn data-id="element-190">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-sand mb-8 md:mb-12 text-center" data-id="element-191">
            Sabés lo que tenés que hacer.
          </h2>
        </FadeIn>

        <div className="space-y-5 md:space-y-8 text-base md:text-xl text-offwhite-dim leading-relaxed" data-id="element-192">
          <FadeIn delay={0.1} data-id="element-193">
            <p className="text-xl md:text-2xl font-medium text-offwhite" data-id="element-194">
              Pero no lo sostenés.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-195">
            <p data-id="element-196">Arrancás bien… y a las horas te caés.</p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-197">
            <p data-id="element-198">Tenés disciplina… pero no paz.</p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-199">
            <p className="text-2xl font-heading font-bold text-amber" data-id="element-200">
              Estás en un loop: pensás mucho, hacés poco, y terminás en el mismo
              lugar.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}